import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent, BaseRoutes, MainContainerComponent } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [
  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        'standardreport',
        () => import('./standard-report/standard-report.module').then(m => m.StandardReportModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'customreport',
        () => import('./custom-report/custom-report.module').then(m => m.CustomReportModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      {
        path: 'manage/reportdesigner',
        data: {
          title,
        },
        loadChildren: () => import('./report-designer/report-designer.module').then(m => m.ReportDesignerModule)
      }
    ],
    () => import('@nts/std').then(mod => mod.EmptyContainerComponent),
  ),
  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }


